import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export const DeductBalance = ({ m, reload }) => {
  const [open, setOpen] = useState(false);
  const [amt, setAmt] = useState("100");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/live-transfers/mlo/${m.id}/deduct`, { amount: Number(amt), note });
      toast.success(`Deducted $${Number(amt).toFixed(2)} from ${m.name}. New balance $${data.balance.toFixed(2)}`);
      setOpen(false); setNote(""); reload();
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <>
      <Button size="sm" variant="link" className="h-auto p-0 text-xs text-red-700" onClick={() => setOpen(true)} data-testid={`queue-deduct-${m.id}`}>Deduct</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="deduct-dialog">
          <DialogHeader><DialogTitle>Deduct from {m.name}'s balance</DialogTitle></DialogHeader>
          <div><Label className="text-xs">Amount ($)</Label>
            <Input type="number" min="0.01" step="0.01" value={amt} onChange={(e) => setAmt(e.target.value)} data-testid="deduct-amount" /></div>
          <div><Label className="text-xs">Reason (shown in their balance history)</Label>
            <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="e.g. Live transfer from 407-555-0100" data-testid="deduct-note" /></div>
          <DialogFooter><Button onClick={save} disabled={busy || !(Number(amt) > 0)} className="bg-red-700 hover:bg-red-800" data-testid="deduct-confirm">Deduct ${Number(amt || 0).toFixed(2)}</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
